import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * tailwind-merge has to be taught about this system's semantic utilities.
 *
 * Out of the box it only knows the framework's own scales. This system's type roles
 * look like `text-row` / `text-legal`, which it cannot tell apart from a text
 * COLOUR — so `cn("text-primary-foreground", "text-support")` would silently
 * drop the colour and render an invisible label.
 *
 * If you add a type role, a radius alias or an easing token to app.css, add it
 * here too. This is the one edit people forget.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [
        {
          text: [
            "mega", "hero", "display", "title", "section", "row", "support", "label", "legal",
          ],
        },
      ],
      rounded: [{ rounded: ["pill", "card", "field", "tile", "inline"] }],
      ease: [{ ease: ["out-ds", "in-out-ds"] }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
